import type { FormState } from '../domain/types';

export const APPLICATION_ROOT_PATH = '/soknad';
export const PARTNER_INBOX_PATH = `${APPLICATION_ROOT_PATH}/innboks`;
export const DIT_TRUST_PROOFS_PATH = '/trust-proofs';

export type ApplicationStepNumber = 1 | 2 | 3 | 4;

export interface ApplicationStep {
  number: ApplicationStepNumber;
  label: string;
  owner: 'kommune' | 'partner';
  path: string;
  aliases?: readonly string[];
}

export const applicationSteps: readonly ApplicationStep[] = [
  { number: 1, label: 'Om prosjektet', owner: 'kommune', path: APPLICATION_ROOT_PATH },
  {
    number: 2,
    label: 'Støtte & vedlegg',
    owner: 'partner',
    path: `${APPLICATION_ROOT_PATH}/stotte`,
    aliases: [PARTNER_INBOX_PATH],
  },
  {
    number: 3,
    label: 'Seriøsitetsbevis',
    owner: 'partner',
    path: `${APPLICATION_ROOT_PATH}/samarbeidspartner`,
  },
  {
    number: 4,
    label: 'Oppsummering',
    owner: 'kommune',
    path: `${APPLICATION_ROOT_PATH}/oppsummering`,
  },
];

export const APPLICATION_TOTAL_STEPS = applicationSteps.length;

function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }

  return pathname;
}

export function getApplicationStep(number: number): ApplicationStep | undefined {
  return applicationSteps.find((step) => step.number === number);
}

export function getApplicationStepByPath(pathname: string): ApplicationStep | undefined {
  const normalizedPath = normalizePath(pathname);

  return applicationSteps.find((step) => {
    if (step.path === normalizedPath) {
      return true;
    }

    return step.aliases?.includes(normalizedPath) ?? false;
  });
}

export function getApplicationStepPath(number: number): string | undefined {
  return getApplicationStep(number)?.path;
}

export function getPreviousApplicationStepPath(number: number): string | undefined {
  return getApplicationStepPath(number - 1);
}

export function getNextApplicationStepPath(number: number): string | undefined {
  return getApplicationStepPath(number + 1);
}

export function getCurrentApplicationStepNumber(pathname: string): ApplicationStepNumber | undefined {
  return getApplicationStepByPath(pathname)?.number;
}

export function isPreLoginStep1(
  pathname: string,
  state: Pick<FormState, 'isLoggedIn' | 'sentToPartner'>
): boolean {
  return normalizePath(pathname) === APPLICATION_ROOT_PATH && !state.isLoggedIn && !state.sentToPartner;
}
